import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useFeatureToggles, useIntl } from '@grandvisionhq/state';
import { generateVirtualAppointmentStoreData } from '../utils.js';

const useVirtualAppointment = ()=>{
    const { featureConfigs  } = useFeatureToggles();
    const { appointmentBookingVirtualAppointmentTypeId , appointmentBookingVirtualAppointmentStoreCode ,  } = featureConfigs !== null && featureConfigs !== void 0 ? featureConfigs : {};
    const { getLabel  } = useIntl();
    const enabled = appointmentBookingVirtualAppointmentTypeId !== undefined && appointmentBookingVirtualAppointmentStoreCode !== undefined;
    const isVirtualAppointmentStore = React.useCallback((store)=>store ? store.code === appointmentBookingVirtualAppointmentStoreCode : false
    , [
        appointmentBookingVirtualAppointmentStoreCode
    ]);
    const isVirtualAppointmentType = React.useCallback((type)=>type ? type.id === appointmentBookingVirtualAppointmentTypeId : false
    , [
        appointmentBookingVirtualAppointmentTypeId
    ]);
    const getStoreData = React.useCallback((store, type)=>{
        if (appointmentBookingVirtualAppointmentStoreCode === undefined || !type) {
            return null;
        }
        return store ? swcHelpers.objectSpread({}, store, {
            appointmentTypes: [
                type
            ]
        }) : generateVirtualAppointmentStoreData(appointmentBookingVirtualAppointmentStoreCode, type);
    }, [
        appointmentBookingVirtualAppointmentStoreCode
    ]);
    const getAppointmentTypeData = React.useCallback((type)=>{
        if (appointmentBookingVirtualAppointmentTypeId === undefined) {
            return null;
        }
        var ref, ref1;
        return swcHelpers.objectSpread({}, type, {
            id: appointmentBookingVirtualAppointmentTypeId,
            name: getLabel('appointments.virtualAppointment.name'),
            description: getLabel('appointments.virtualAppointment.description'),
            ageGroup: 'ADULT',
            duration: (ref = type === null || type === void 0 ? void 0 : type.duration) !== null && ref !== void 0 ? ref : {
                amount: 0,
                unit: 'MINUTES'
            },
            isVisibleToCustomers: (ref1 = type === null || type === void 0 ? void 0 : type.isVisibleToCustomers) !== null && ref1 !== void 0 ? ref1 : false
        });
    }, [
        appointmentBookingVirtualAppointmentTypeId,
        getLabel
    ]);
    return React.useMemo(()=>[
            {
                isVirtualAppointmentStore,
                isVirtualAppointmentType,
                getStoreData,
                getAppointmentTypeData
            },
            {
                enabled,
                storeCode: appointmentBookingVirtualAppointmentStoreCode,
                typeId: appointmentBookingVirtualAppointmentTypeId
            }, 
        ]
    , [
        isVirtualAppointmentStore,
        isVirtualAppointmentType,
        getStoreData,
        getAppointmentTypeData,
        enabled,
        appointmentBookingVirtualAppointmentStoreCode,
        appointmentBookingVirtualAppointmentTypeId, 
    ]);
};

export { useVirtualAppointment as default, useVirtualAppointment };
//# sourceMappingURL=use-virtual-appointment.js.map
